module.exports = __webpack_public_path__ + "img/icon-suche.c9c5e785.svg";